const attendanceInformationSchema = {
  attendanceDateTime: {
    displayName: 'Data e hora do atendimento',
    type: 'datetime',
    notAvailable: 'Não informado',
  },
  icd10Description: {
    displayName: 'CID-10',
    type: 'string',
    notAvailable: 'Não informado',
  },
  icpc2Description: {
    displayName: 'CIAP-2',
    type: 'string',
    notAvailable: 'Não informado',
  },
  professionalName: {
    displayName: 'Nome do profissional de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  healthUnitName: {
    displayName: 'Nome da unidade de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  teamName: {
    displayName: 'Nome da equipe de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  weight: {
    displayName: 'Peso',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'weightKg',
  },
  height: {
    displayName: 'Altura',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'heightMeter',
  },
  typeOfAttendance: {
    displayName: 'Tipo de atendimento',
    type: 'string',
    notAvailable: 'Não informado',
  },
  isVaccinationUpToDate: {
    displayName: 'Vacinação em dia',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  lastMenstruationDate: {
    displayName: 'Data da última menstruação',
    type: 'date',
    notAvailable: 'Não informado',
  },
  isObservation: {
    displayName: 'Observação',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasReferralToUrgency: {
    displayName: 'Encaminhamento para urgência',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasReferralToHomeCareService: {
    displayName: 'Encaminhamento para serviço de atenção domiciliar',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasIntersectoralReferral: {
    displayName: 'Encaminhamento intersetorial',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isScheduleReturn: {
    displayName: 'Agendamento de retorno',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isScheduleForGroups: {
    displayName: 'Agendamento para grupos',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isScheduleForNasf: {
    displayName: 'Agendamento para NASF',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isScheduleForContinuedCare: {
    displayName: 'Agendamento para cuidado continuado',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isEpisodeDischarge: {
    displayName: 'Alta de episódio',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasReferralToSpecializedService: {
    displayName: 'Encaminhamento para serviço especializado',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasReferralToCaps: {
    displayName: 'Encaminhamento para CAPS',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  hasReferralToHospitalization: {
    displayName: 'Encaminhamento para internação',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
}

export default attendanceInformationSchema
